import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  viewChild,
} from '@angular/core';
import { OptionDirective } from '../../../../../directives/option.directive';
import { CustomColumnDefinition } from '../../../types/column.type';
import { CellAdapter } from '../cell-adapter.component';

@Component({
  selector: 'lepi-custom-cell',
  template: ` <ng-template option /> `,
  standalone: true,
  imports: [OptionDirective],
})
export class CustomCell extends CellAdapter implements AfterViewInit {
  private readonly changeRef = inject(ChangeDetectorRef);
  private readonly customCell = viewChild(OptionDirective);
  private componentRef?: any;

  constructor() {
    super();

    // row 또는 column이 변경될 때마다 동적 컴포넌트의 입력을 업데이트
    effect(() => {
      const row = this.row();
      const column = this.column();

      if (this.componentRef) {
        this.componentRef.setInput('row', row);
        this.componentRef.setInput('column', column);
        this.changeRef.detectChanges();
      }
    });
  }

  ngAfterViewInit(): void {
    const column = this.column() as CustomColumnDefinition;

    if (this.customCell() && column.type === 'custom' && column.renderItem) {
      const viewContainerRef = this.customCell()?.viewContainerRef;
      viewContainerRef?.clear();

      this.componentRef = viewContainerRef?.createComponent<CellAdapter>(
        column.renderItem
      );

      // 초기값 설정
      this.componentRef?.setInput('row', this.row());
      this.componentRef?.setInput('column', this.column());

      this.changeRef.detectChanges();
    }
  }
}
